import {
  type Color,
  fontClasses,
  sizeClasses,
  type TextSize,
  type Weight,
} from "@/types/ui/design";
import React from "react";
import { Link } from "react-router";

type PennLinkProps = {
  children: React.ReactNode;
  size?: TextSize;
  color?: Color;
  font?: Weight;
  className?: string;
  to: string;
};

const PennLink = ({
  children,
  size = "sm",
  color = "blue",
  font = "normal",
  className = "",
  to = "/",
}: PennLinkProps) => {
  return (
    <>
      <Link
        to={to}
        className={`${sizeClasses[size]} ${fontClasses[font]} ${className} text-${color}  hover:text-penn-700 transition-colors `}
      >
        {children}
      </Link>
    </>
  );
};

export default PennLink;
